export { default as default } from './MarcatgeEstructurat';
